import axios from 'axios';

const baseURL: string = process.env.REACT_APP_BASE_URL ?? '';
const ERROR_LOG_URL = `${baseURL}/log/client-error`;

let isSending = false;

interface ErrorPayload {
  message: string;
  stack?: string;
  url?: string;
  userAgent?: string;
  component?: string;
  context?: string;
}

export function sendErrorLog(payload: ErrorPayload) {
  if (isSending) return;
  isSending = true;

  const data: ErrorPayload = {
    ...payload,
    url: payload.url || window.location.href,
    userAgent: payload.userAgent || navigator.userAgent,
  };

  axios
    .post(ERROR_LOG_URL, data)
    .catch(() => {})
    .finally(() => {
      isSending = false;
    });
}

export function initErrorLogger() {
  window.onerror = (message, source, lineno, colno, error) => {
    sendErrorLog({
      message: String(message),
      stack: error?.stack,
      url: window.location.href,
      context: `onerror:${source}:${lineno}:${colno}`,
    });
  };

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    sendErrorLog({
      message: reason?.message || String(reason),
      stack: reason?.stack,
      url: window.location.href,
      context: 'unhandledrejection',
    });
  });
}
